export const getTrackingNameByExportNumber = (quota: number, exportingQuantity: number) => {
    if (quota === exportingQuantity) {
        return "all quota";
    }

    if (exportingQuantity === 100) {
        return "top 100";
    }

    return "manual selection";
};
